import { $, $$, closest } from 'utils/dom';
import TEMPLATE from './lightbox-template';
import './Lightbox.scss';
import './skin.scss';

export default class Lightbox {
  TEMPLATE_SELECTOR = '.pswp';

  constructor(container, config) {
    this.container = container;
    this.selector = config.selector;

    this.templateIsAdded = this.isTemplateAdded();
    this.template = this.templateIsAdded
      ? $(this.TEMPLATE_SELECTOR)
      : new DOMParser().parseFromString(TEMPLATE, 'text/html').body.firstChild;
    !this.templateIsAdded && document.body.appendChild(this.template);

    this.options = {
      timeToIdle: 40000,
      timeToIdleOutside: 40000,
      loadingIndicatorDelay: 1000,
      index: 0,
      bgOpacity: 0.95,
      showHideOpacity: true,
      history: false,
      closeOnScroll: false,
      spacing: 0.3,
    };
    this.items = $$(this.selector, this.container);

    if (this.container.classList.contains('lightbox-album')) {
      this.slides = this.getAlbumSlides();
    } else {
      this.slides = this.getSlides(this.items);
    }

    this.pswp = null;
  }

  isTemplateAdded = () => $(this.TEMPLATE_SELECTOR);

  getSlides = items => {
    return items.flatMap(item => {
      const dataset = item.dataset;
      const { src, size, title, description, copyright } = dataset;
      const sizes = size.split('x');
      const w = parseInt(sizes[0], 10);
      const h = parseInt(sizes[1], 10);

      return { src, w, h, imageTitle: title, title: description, copyright };
    });
  };

  getAlbumSlides = () => {
    const item = $('.lightbox-toggle', this.container);
    const { album } = item.dataset;
    const parseSlidesJson = JSON.parse(album);

    return parseSlidesJson.map(slide => ({
      src: slide.src,
      w: slide.width,
      h: slide.height,
      imageTitle: slide.imageTitle,
      title: slide.title,
      copyright: slide.copyright,
    }));
  };

  bindEvents = () => {
    this.items.forEach(item => item.addEventListener('click', this.open));
  };

  getIndex = slide => {
    switch (typeof slide) {
      case 'number':
        return slide;
      case 'object':
        return this.items.indexOf(closest(slide.target, this.selector));
      default:
        return null;
    }
  };

  setImageTitle = item => {
    item.imageTitle &&
      (document.getElementById('pswp_imagetitle').textContent =
        item.imageTitle);
    document.getElementById('pswp__captiontext').textContent = item.title;
    document.getElementById('pswp__copyright').textContent = item.copyright;
  };

  setCounter = (index, totalLength) => {
    $('.pswp__counter').innerHTML = `<span class="index">${
      index + 1
    }/</span>${totalLength}`;
  };

  cloneCaption = ({ imageTitle, title, copyright }) => {
    /*
     * User cant select the caption text, because it will always trigger the swipe event.
     * So we clone the caption and set it outside of the swipe-element.
     * */
    $('.pswp--is-clone .pswp_imagetitle').textContent = imageTitle || '';
    $('.pswp--is-clone .pswp__captiontext').textContent = title || '';
    $('.pswp--is-clone .pswp__copyright').textContent = copyright || '';
  };

  // `slide` could be an event or an index
  open = slide => {
    const { template, slides, options } = this;
    // Opens selected slide
    options.index = this.getIndex(slide);

    if (options.index !== -1) {
      return Promise.all([
        import(/* webpackChunkName: 'photoswipe' */ 'photoswipe'),
        import(
          /* webpackChunkName: 'PhotoSwipeUI' */ 'photoswipe/dist/photoswipe-ui-default'
        ),
      ]).then(([ps, psui]) => {
        const PhotoSwipe = ps.default;
        const PhotoSwipeUI = psui.default;

        this.pswp = new PhotoSwipe(template, PhotoSwipeUI, slides, options);

        this.pswp.init();
        this.setImageTitle(this.pswp.currItem);
        this.setCounter(options.index, this.slides.length);
        this.cloneCaption(this.pswp.currItem);

        this.preventContextMenu('.pswp__container');

        this.pswp.listen('afterChange', () => {
          this.setImageTitle(this.pswp.currItem);
          this.setCounter(this.pswp.getCurrentIndex(), this.slides.length);
          this.cloneCaption(this.pswp.currItem);
        });
      });
    } else {
      return Promise.resolve();
    }
  };

  preventContextMenu = (selector, p = document) => {
    $$(selector, p).forEach(el => {
      el.addEventListener('contextmenu', e => e.preventDefault());
    });
  };

  unbindEvents = () => {
    this.items.forEach(item => item.removeEventListener('click', this.open));
  };

  init = () => {
    this.bindEvents();
  };
}
